const { VEHICLE_REGISTRATION_METHOD } = require("../../constants");
const { getVehicleRegistrationType } = require("./getVehicleRegistrationType");

// Accepts any vehicleRegistration shape via getVehicleRegistrationType (canonical
// { type: string }, legacy bare string, or corrupt). Only an explicit "Myself" counts as
// customer-selected; nonsense resolves to Citroën and therefore returns false.
const getIsVehicleRegistrationByCustomerSelected = registrationType =>
  getVehicleRegistrationType(registrationType) ===
  VEHICLE_REGISTRATION_METHOD.MYSELF;

module.exports = { getIsVehicleRegistrationByCustomerSelected };
